import { WHATSAPP_LINK } from "@/data/site";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { SalonAssistant } from "@/components/SalonAssistant";

export const FloatingActions = () => (
  <>
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-slate-950 shadow-lg shadow-black/40 hover:scale-105 transition-transform"
    >
      <WhatsAppIcon className="w-7 h-7" />
    </a>
    <SalonAssistant />
  </>
);
